/* Decor Walay — latest-news.js
   Prev/next crossfade navigation between blog article slides. */

document.addEventListener('DOMContentLoaded', function () {
  Array.prototype.slice.call(document.querySelectorAll('[data-news-slider]')).forEach(function (slider) {
    var slides = Array.prototype.slice.call(slider.querySelectorAll('.latest-news__slide'));
    if (slides.length < 2) return;

    var current = 0;
    var prevBtn = slider.querySelector('[data-news-prev]');
    var nextBtn = slider.querySelector('[data-news-next]');

    function goTo(index) {
      slides[current].classList.remove('is-active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('is-active');
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });
  });
});
